export default {
  signUpSuccess: 'Hello there! Start your journey now!',
  signUpFailure: 'Error: Something went wrong. Please try again.',
  signInSuccess: 'Welcome! It\'s great to see you!',
  signInFailure: 'Error: Something went wrong. Please try again.',
  signOutSuccess: 'Hope to see you again soon!',
  changePasswordSuccess: 'You have successfully changed passwords!',
  changePasswordFailure: 'Error: Something went wrong. Please try again.'
}



// WEBPACK FOOTER //
// ./src/auth/messages.js